export enum EnumPromocaoTipoRegra {
    DePor = 0,
    AtacadoValor = 1,
    AtacadoPerc = 2,
    LeveMaisPagueMenosQtde = 3,
    ProgressivoPerc = 4,
}